import { render, staticRenderFns } from "./GIconLink.vue?vue&type=template&id=0e2ead2c&scoped=true&"
import script from "./GIconLink.vue?vue&type=script&lang=ts&"
export * from "./GIconLink.vue?vue&type=script&lang=ts&"
import style0 from "./GIconLink.vue?vue&type=style&index=0&id=0e2ead2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2ead2c",
  null
  
)

export default component.exports